module.exports = __webpack_public_path__ + "img/hungary.8061e6ff.svg";